import React, { FunctionComponent } from 'react';

export const Presentation: FunctionComponent = () => {
  return (
    <div className="rtf-top-links">
      {/* start privacy */}
      <div className="privacy">
        <div className="privacy-body">
            <h2 className="title">プライバシーポリシー</h2>
            <p>株式会社READY TO FASHION（以下「当社」といいます。）は、当社が提供するサービスなどにおいてご利用者に関する情報を保護するため、個人情報の保護に関する法律（平成15年法第57号）（以下「個人情報保護法」といいます。）その他関連する法令などを遵守し、以下の方針（以下「本方針」といいます。）をとります。</p>


            <p>1 （定義）</p>
            <ul>
                <li>(1) 本方針において、「個人情報」とは、個人情報保護法にいう個人情報を指すものとします。</li>

                <li>(2) 本方針において、「履歴情報および特性情報」とは、上記に定める「個人情報」以外の当社がサービスを提供するにあたってご利用者から収集される情報をいい、ご利用されたサービスの利用履歴、ご覧になったページや広告の履歴、ご利用者が投稿などに利用したキーワード、ご利用日時、ご利用方法、ご利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態、ご利用に際しての各種設定情報などを含みます。）、郵便番号、性別、年齢、職業、IPアドレス、クッキー情報、クレジットカード情報、端末の個体識別情報などを指します。</li>
            </ul>
            <p>2 （個人情報などの取得）</p>
            <ul>
                <li>当社は、以下の場合に、当社のサービスまたは当社を経由してご利用いただく当社の提携先（情報提供元、広告主、広告配信先などを含みます。以下｢提携先｣といいます。）のサービスを提供するために必要な範囲に限って、適法かつ公正な手段によって、以下のとおりご利用者の個人情報などを取得します。</li>

                <li>(1) 当社サービスを利用するためのアカウントへの登録を行う際ならびに当社サービスに申し込む際および当社サービスを利用するためのアカウントへの登録を行う際ならびに当社サービスに申し込む際および当社サービスを利用する際に、氏名、生年月日、お住いの都道府県、メールアドレス、電話番号などの情報をお尋ねすることがあります。</li>

                <li>(2) Facebook、Twitter、LINEその他の外部のサービス（以下「外部サービス」といいます。）のアカウントを用いて当社サービスを利用する際に、氏名、生年月日、お住いの都道府県などの情報を取得することがあります。</li>

                <li>(3) 当社サービス上でプロフィールページや人材の募集を行うページを作成する際に、氏名、生年月日、年齢、性別、メールアドレス、電話番号、所在地、学歴、職歴、職業、資格、プロフィール画像などの情報をお尋ねすることがあります。</li>

                <li>(4) ご利用者が当社の提供する有料サービスを利用される場合においてクレジットカード決済を希望されるときには、クレジットカード情報などの情報をお尋ねすることがあります。</li>

                <li>(5) ご利用者を特定する必要がある場合や、当社にお問い合わせいただいた場合に、氏名、生年月日、住所、メールアドレス、電話番号などの情報をお尋ねすることがあります。</li>

                <li>(6) ご利用者と提携先との間でなされたご利用者の個人情報を含む取引記録・決済に関する情報を、当該提携先から取得することがあります。</li>
            </ul>
            <p>3 （個人情報の利用目的）</p>
            <ul>
                <li>当社は、当社が取得した個人情報を、以下の目的のために利用します。</li>

                <li>(1) 当社が定める利用規約に基づき当社サービスを適切に提供するため（本人認証、利用者情報の表示、利用者情報の管理を含みます。）</li>

                <li>(2) ご利用者にご自身の登録情報の閲覧や修正、ご利用状況の閲覧を行っていただくために必要な情報を表示するため（①当社サービス上でのプロフィールページ（氏名、生年月日、年齢、性別、メールアドレス、電話番号、所在地、学歴、職歴、職業、資格、プロフィール画像などを含みます。）、および、②当社サービス上で掲載企業（法人、個人事業主を含みます。以下同じ。）が人材の募集を行うページ（氏名、メールアドレス、電話番号、所在地、プロフィール画像などを含みます。）の作成・修正・閲覧のためを含みます。）</li>

                <li>(3) ご利用者のご本人確認を行うため</li>

                <li>(4) ご利用者の公開設定あるいは当社サービスの仕様に従い、当社サービス上で掲載企業を含む他のご利用者またはインターネットを閲覧している第三者の閲覧に供するため、および、ご利用者の公開設定あるいは当社サービスの仕様に従い、ご利用者同士のメッセージ送信などのコミュニケーションを可能にするため</li>

                <li>(5) 当社サービスを運営する上でご利用者にお知らせやご連絡を行うため</li>

                <li>(6) 新サービス情報のお知らせや関連するアフターサービスのため</li>

                <li>(7) 当社がユーザーの皆様にとって有用と考えるメールマガジンの配信のため</li>

                <li>(8) ご利用者が当社および提携先のサービスを利用するにあたり簡便にデータを入力できるようにするため</li>

                <li>(9) 提携サービス提供のため（ご利用者が提携先のサービスなどに申込みを行う際に、個人情報のうち申込みに必要な情報を当該提携先に開示するため、提携先のサービスなど、当社以外の第三者が提供するサービスに関するお問い合わせを、当社がご利用者から受けた場合で、お問い合わせに対する回答を提携先から直接行うことが適切であると当社が判断した場合、お問い合わせの内容およびメールアドレスなどの連絡先を当該提携先に対して開示するためを含みます。）</li>

                <li>(10) 当社の利用規約に違反したユーザーのご利用をお断りするため（当社の利用規約に違反した方のご利用をお断りするために、個人の特定に必要な範囲で個人情報を提携先などに対して開示するためを含みます。）</li>

                <li>(11) 当社サービスへのご質問、ご意見、お問い合わせなどに対して回答を行うため</li>

                <li>(12) 当社サービスのご利用に関連して、ご利用者が法令に違反した疑いがあると認めた官公庁から、ご利用者と直接連絡を取るために必要な情報の開示の求めがあった場合において、当該求めに応じることが適切であると当社が判断した場合に、連絡先を当該官公庁に対して開示するため</li>

                <li>(13) 当社サービスの終了や当社と第三者との事業提携などに伴って、第三者が当社サービスの全部もしくは一部を承継する場合などに、当社サービスの承継や統合に必要な範囲で個人情報を当該第三者に対して提供するため</li>

                <li>(14)弁護士など守秘義務を負う者に対して、法律相談などに関連して必要最小限の範囲で開示するため</li>
            </ul>
            <p>4 （個人情報の第三者への提供）</p>
            <ul>
                <li>当社は、以下の場合には、個人情報を第三者に提供することがあります。</li>

                <li>(1) 法令に基づく場合</li>

                <li>(2) ご利用者の同意をいただいた場合</li>

                <li>(3) 人の生命、身体または財産の保護のために必要がある場合であって、ご利用者の同意を得ることが困難であるとき</li>

                <li>(4) その他、個人情報保護法その他の法令上許容される場合</li>
            </ul>
            <p>5 （履歴情報および特性情報の取得）</p>
            <ul>
                <li>(1) 当社は、ご利用者が当社サービスを利用するためのアカウントに登録する際ならびに当社サービスに申し込む際および当社サービスを利用する際に、履歴情報および特性情報をお尋ねする場合があります。</li>

                <li>(2) 当社は、履歴情報および特性情報を、ご利用者が当社サービスや提携先のサービスをご利用になったときやページをご覧になったときに取得します。</li>
            </ul>
            <p>6 （履歴情報および特性情報の利用目的）</p>
            <ul>
                <li>当社は、当社が取得した履歴情報および特性情報を、以下の目的のために利用します。</li>

                <li>(1) ログインが必要なサービスにおいて、同じご利用者からのアクセスかどうかを確認するため</li>

                <li>(2) ご利用者のセキュリティを確保するため、ログイン後に一定の時間が経過したご利用者に対してログイン情報の再入力を促すため</li>

                <li>(3) 当社や当社から広告を配信している提携先サイトのご利用者数および当社や提携先サイトへの誘導数を調査するため</li>

                <li>(4) 当社や提携先が、ご利用者に対して最適なコンテンツ、広告、各種サービスのご案内を提供するため</li>

                <li>(5) 当社や提携先が提供しているサービスや広告の内容を改善するため、または新しいサービスを開発するために、必要な分析・情報の抽出などを行うため</li>

                <li>(6) ご利用者からのお問い合わせに対応するために、ご利用者におけるサービスのご利用状況を確認するため</li>
            </ul>
            <p>7 （個人情報の閲覧・訂正・追加・削除）</p>
            <ul>
                <li>(1) 当社は、ご利用者からご自身の個人情報の照会の申し出があった場合には、合理的な範囲で個人情報を開示します。</li>

                <li>(2) 当社の保有する個人情報の内容が事実と異なる場合など、個人情報の訂正、削除、利用の停止などをお申し出になる場合、ご利用者は、当社に対してメールにてご連絡ください。ご連絡をいただいてから合理的な範囲で遅滞なく調査を行い、その結果に基づき、当社の判断により個人情報を訂正、追加または削除します。</li>
            </ul>
            <p>8 （外部サービス、外部リンクについて）</p>
            <ul>
                <li>(1) 当社は、外部サービスと連携して当社サービスを提供する場合があり、ご利用者が、外部サービス上で個人情報その他の情報を公開し、または外部サービスと連携するサービス上で個人情報その他の情報の利用を許諾した場合、当社サービスにおいても個人情報その他の情報が公開される場合がありますので、ご了承ください。情報の公開範囲の設定方法などについては、外部サービスのプライバシーポリシーなどをご確認ください。</li>

                <li>(2) 当社サービスは、外部サイトへのリンクを含んでいますが、リンク先の外部サイトにおける個人情報その他の情報の取扱いについて、当社は責任を負いかねます。リンク先の外部サイトのご利用に際しては、各サイトのプライバシーポリシーをご確認ください。</li>
            </ul>

            <p>9 （安全管理体制）</p>
            <ul>
                <li>(1) 当社は、ご利用者の個人情報ならびに履歴情報および特性情報の漏洩、滅失または毀損を防止するため、個人情報ならびに履歴情報および特性情報へのアクセス制限の実施、外部からの不正アクセスの防止のための措置など、安全管理のために必要かつ適切な措置を講じます。</li>

                <li>(2) 当社は、代表取締役を個人情報ならびに履歴情報および特性情報の管理責任者として、適正な管理および継続的な改善を実施します。</li>
            </ul>
            <p>10 （プライバシーポリシーの変更）</p>
            <ul>
                <li>(1) 当社は、個人情報保護法その他の関係法令・規範を遵守するとともに、本方針の内容を継続的に見直し、改善に努めます。</li>

                <li>(2) 本方針の内容を変更する場合は、当社サービスにかかるウェブサイトあるいはアプリへの掲示その他ご利用者にわかりやすい方法により告知します。ただし、法令上ご利用者の同意が必要となるような内容の変更を行うときは、別途当社が定める方法により、ご利用者の同意を取得します。</li>
            </ul>
            <p>11 （お問い合わせ先）</p>
            <ul>
                <li>当社における個人情報ならびに履歴情報および特性情報の取扱いに関するご意見、ご質問その他のお問い合わせは、当社が指定するメールアドレス（ユーザーの皆様：info.service@readytofashion.jp、掲載企業の皆様：info@readytofashion.jp）宛てのメールにより行ってください。当社は、お問い合わせに対する回答を原則としてメールのみで行います。なお、当社は、お問い合わせに対して回答する義務を負うものではありません。</li>
            </ul>
            <p>2017年1月20日 制定・適用<br />
               2019年1月15日 改訂・適用</p>
        </div>
      </div>
      {/* end privacy */}
    </div>
  );
};
